<template>
	<div v-if="show" class="city-dialog">
		<div class="dialog flex flex-direction">
			<div class="diaTop flex justify-between align-center pointer" @click="colseCity">
				<div class="title"></div>
				<div class="close pointer"><img src="@/assets/images/index/close.png" /></div>
			</div>
			<div class="dia-content">
				<div class="item-box" v-if="hot && hot.length">
					<div class="title">热门</div>
					<div class="item-list flex site">
						<p class="text"
							v-for="(item,index) in hot" :key="index" @click="clickEmit(item,index)">
							{{ item.name }}</p>
					</div>
				</div>
				<div class="item-box">
					<div class="title">省份</div>
					<div class="item-list flex">
						<p class="text" :class="{'select':curProvince == index}"
							v-for="(item,index) in provinceStationInfo" :key="index" @click="clickProvince(item,index)">
							{{item.provinceName | formatterProvince}}</p>
					</div>
				</div>
				<div class="item-box" v-show="showCity && cityStationInfo.length">
					<div class="title">城市</div>
					<div class="item-list flex">
						<p class="text" :class="{'select':curCity==index}" v-for="(item, index) in cityStationInfo"
							:key="index" @click="clickCity(item, index)">{{ item.cityName }}</p>
					</div>
				</div>
				<div class="item-box" v-show="showDistrict && districtStationInfo.length">
					<div class="title">区域</div>
					<div class="item-list flex">
						<p class="text" :class="{'select':curDistrict==index}"
							v-for="(item,index) in districtStationInfo" :key="index" @click="clickDistrict(item,index)">
							{{ item.districtName }}</p>
					</div>
				</div>
                <!-- {{ siteList }} -->
				<div class="item-box" v-show="siteList.length">
					<div class="title">站点</div>
					<div class="item-list flex site">
						<p class="text"
							v-for="(item,index) in siteList" :key="index" @click="clickEmit(item,index)">
							{{ item.stationName }}</p>
					</div>
				</div>
			</div>

			<div v-if="type != 'site'" class="diaBottom flex">
				<button class="confirm pointer" @click="confirm">确定</button>
			</div>
		</div>
	</div>
</template>

<script>
import { formatter } from '@/utils/index.js'
import { indexCenter } from '@/api/indexCenter'
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        },
        hot: {
            type: Array,
            default: () => { return []}
        }
    },
    data() {
        return {
            provinceStationInfo: [],
            showCity: false,
            curProvince: -1,
            curDistrict: -1,
            curCity: -1,
            cityStationInfo: [],
            showDistrict: false,
            districtStationInfo: [],
            siteList: [],
            provinceObj: {},
            districtObj: {},
            cityObj: {},
            
        }
    },
    filters: {
        formatterProvince(name){
        if(!name) return '';
            console.log(name)
            return formatter(name)
        },
    },
    mounted() {
        this.selectCountryStationInfo()
    },
    methods: {
        //清空数据
        clearData(){
            this.districtStationInfo.length = 0
            this.cityStationInfo.length = 0
            this.curProvince = -1
            this.curDistrict = -1
            this.curCity = -1
        },
        //点击省级 区分 直辖市和其他
        clickProvince(item, index) {
            this.clearData();
            let adcode = parseInt(item.province);
            this.adcode = adcode;
            this.provinceObj = item
            let updateParams = {};
            if (this.curProvince == index) {
                return;
            }
            this.curProvince = index;
            if ([110000, 120000, 500000, 310000].includes(adcode)) {
                updateParams = {
                    city: adcode.toString().substring(0, 2) + '0100'
                }
                this.selectCityStationInfo(updateParams)
            } else {
                updateParams = {
                    province: adcode
                }
                this.selectProvinceStationInfo(updateParams);
            }
        },
        clickCity(item, index) {
            if (this.curCity != index) {
                this.curCity = index;
                this.adcode = item.city;
                this.cityObj = item
                this.selectCityStationInfo({
                    'city': item.city
                })
            }
        },
        clickDistrict(item, index) {
            if (this.curDistrict != index) {
                this.curDistrict = index
                this.adcode = item.district
                this.districtObj = item
                if(this.type === 'site') {
                    // 获取区域站点信息
                    this.selectSiteInfo()
                }
            }
        },
        clickEmit(item) {
            this.$emit('upData', item)
            this.$emit('update:show', false)
        },
        colseCity() {
            this.$emit('update:show', false)
        },
        //确定按钮
        confirm() {
            if (this.curProvince == -1 && this.curCity == -1 && this.curDistrict == -1) {
                console.log("您还没有选择省份");
                return;
            }
            if (this.curProvince > -1 && this.curCity == -1 && this.curDistrict == -1) {
                console.log("选择省份");
                this.colseCity() //关闭弹框
                this.$emit('upData', {
                    province: this.adcode,
                    name: this.provinceObj.provinceName
                })
                // this.$router.push({
                //     path: '/pcnationwideSite',
                //     query: {
                //         province: this.adcode
                //     }
                // })
                return;
            }
            if (this.curProvince > -1 && this.curCity > -1 && this.curDistrict == -1) {
                console.log("选择城市");
                this.colseCity() //关闭弹框
                this.$emit('upData', {
                    city: this.adcode,
                    name: `${this.provinceObj.name}-${this.city.cityName}`
                })
                // this.$router.push({
                //     path: '/pcnationwideSite',
                //     query: {
                //         city: this.adcode
                //     }
                // })
                return;
            }

            if (this.curProvince > -1 && this.curCity > -1 && this.curDistrict > -1) {
                console.log("选择城市");
                this.colseCity() //关闭弹框
                this.$emit('upData', {
                    adcode: this.districtObj.district,
                    name: `${this.provinceObj.name}-${this.city.name}-${this.districtObj.districtName}}`
                })
                // this.$router.push({
                //     path: '/pcdistrict',
                //     query: {
                //         adcode: this.districtObj.district
                //     }
                // })
                return;
            }

        },
        //获取全国站点数据
        selectCountryStationInfo() {
            let _this = this;
            indexCenter
                .selectCountryStationInfo()
                .then((res) => {
                    if (!res) return;
                    this.provinceStationInfo = res;
                })
                .catch((err) => {});
        },
        //获取省级站点数据
        selectProvinceStationInfo(updateParams) {
            let _this = this;
            //获取省的站点信息
            indexCenter
                .selectProvinceStationInfo(updateParams)
                .then((res) => {
                    if (!res) return;
                    this.cityStationInfo = res;
                    if (res.length > 0) {
                        this.showCity = true;
                        this.showDistrict = false;
                    } else {
                        this.showCity = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        //获取区级站点数据
        selectCityStationInfo(updateParams, adcode, type) {
            let _this = this;
            //获取省的站点信息
            indexCenter
                .selectCityStationInfo(updateParams)
                .then((res) => {
                    if (!res) return;
                    this.districtStationInfo = res;
                    if (res.length > 0) {
                        this.showDistrict = true;
                    } else {
                        this.showDistrict = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 获取站点信息
        selectSiteInfo() {
            let params = {
                "enCode": "TiDB-zhandian-zhandianjingweidu",
                "@province": this.adcode
            }
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('stationxinxi============', res)
                    if(!res || !res.length || !res[0]) return {}
                    this.siteList = res || []
                })
                .catch((err) => {
                    console.log(err);
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.city-dialog {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba( #000000, 0.5);
    z-index: 10;
    .diaTop {
        .close {
            width: 70px;
            height: 70px;
            > img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .dialog {
        background: linear-gradient(180deg,#1d545c,rgba(36,98,96,.8));
        width: 1400px;
        height: 1000px;
        overflow-y: scroll;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 40px;
        font-size: 36px;
        box-sizing: border-box;
        .dia-content {
            .item-box {
                .item-list {
                    flex-wrap: wrap;
                    .text {
                        width: 180px;
                        height: 70px;
                        margin-top: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &.select {
                            // border-radius: ;
                            border: 1px solid #2afffb;
                            border-radius:  70px;
                            background: rgba(42,255,251,.23);
                        }
                    }
                    &.site {
                        .text {
                            width: auto;
                            margin-right: 40px;
                        }
                    }
                }
            }
        }
        .diaBottom {
            justify-content: flex-end;
            .confirm {
                width: 200px;
                height: 70px;
                background: linear-gradient(180deg,rgba(10,98,96,.6),rgba(1,177,169,.6));
                border-radius: 0.028571rem;
            }
        }
    }
}
</style>